import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalCommunicationService {
  private openRegisterModalSubject = new BehaviorSubject<boolean>(false);
  public openRegisterModal$ = this.openRegisterModalSubject.asObservable();

  triggerOpenRegisterModal() {
    this.openRegisterModalSubject.next(true);
  }

  resetModalTrigger() {
    this.openRegisterModalSubject.next(false);
  }
}